<ion-content class="ion-padding ion-text-center">
  <div class="container">
    @switch (state) {
      @case (InviteState.INIT) {
        <ion-icon name="cloud-upload-outline" class="icon-animate"></ion-icon>

        <h1>Du wirst zur Site hinzugefügt …</h1>
        <p>Bitte einen Moment Geduld, die Verbindung wird hergestellt.</p>

        <ion-spinner name="crescent" class="spinner"></ion-spinner>
      }

      @case (InviteState.OK) {
        <ion-icon name="checkmark-circle-outline" class="icon-success"></ion-icon>

        <h1>Du wurdest erfolgreich zur Site hinzugefügt 🎉</h1>
        <p>Hier geht es zur Übersicht deiner Sites.</p>

        <ion-button
          expand="block"
          color="primary"
          [routerLink]="['overview']"
          class="ion-margin-top"
        >
          Zur Übersicht
        </ion-button>
      }

      @case (InviteState.ERROR) {
        <ion-icon name="alert-circle-outline" class="icon-error"></ion-icon>

        <h1>Ups... Etwas ist schief gelaufen 😕</h1>
        <p>Bitte klicke erneut auf den Link in der E-Mail oder lasse dich neu einladen.</p>

        <ion-button
          expand="block"
          color="medium"
          [routerLink]="['overview']"
          class="ion-margin-top"
        >
          Zur Übersicht
        </ion-button>
      }
    }
  </div>
</ion-content>
